<script setup lang="ts">
import ButtonRegular from './ButtonRegular.vue'

defineProps({
  size: {
    type: String as () => '32' | '44' | '50',
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <ButtonRegular
    class="bg-white px-0 py-16 text-black active:bg-gray-400 disabled:bg-white"
    :size="size"
    :disabled="disabled"
  >
    <slot />
  </ButtonRegular>
</template>
